// TEMP FILE
// Will be removed when frontend is hooked up with php backend
import { UserTypes } from 'modules/User';

export const MOCK_ICON_PACK_DATA = [
  {
    id: 1,
    name: 'Activities and Interactions',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Business,
    order: 5,
    displayIconIds: [
      'ui_banners_people_man_having_a_drink_at_the_bar',
      'ui_banners_people_older_man_with_walking_stick_2',
      'ui_banners_people_man_throwing_paper_airplane',
      'ui_banners_people_photographer_with_camera',
      'ui_banners_people_film_director',
      'ui_banners_people_man_travelling',
      'ui_banners_people_man_standing',
      'ui_banners_people_man_serving_food',
      'ui_banners_christmas_elements_working_santa',
      'ui_banners_people_cool_guy',
    ],
  },
  {
    id: 2,
    name: 'Cultural Pack',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Premium,
    order: 9,
    displayIconIds: [
      'germany_house2',
      'canada_snowflake2',
      'thailand_lotus2',
      'spain_paella2',
      'thailand_coconut2',
      'canada_hat2',
      'chile_cultrun2',
      'germany_pretzel2',
      'chille_moai2',
      'thailand_temple2',
    ],
  },
  {
    id: 3,
    name: 'Cultural Mono',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 11,
    displayIconIds: [
      'canada_hat',
      'chile_empanada',
      'canada_syrup',
      'thailand_temple',
      'chile_avocado',
      'thailand_stupa',
      'spain_wine',
      'chile_cultrun',
      'spain_cathedral',
      'canada_hockey',
    ],
  },
  {
    id: 4,
    name: 'Retro Essentials',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Premium,
    order: 5,
    displayIconIds: [
      'ricon-pan',
      'ricon-female-gender',
      'ricon-presentation-video-audio',
      'ricon-trash-14',
      'ricon-bookmark-crate',
      'ricon-identification-badge',
      'ricon-eraser-graphic-design-tools',
      'ricon-holed-document',
      'ricon-location-map',
      'ricon-delete-shopping-cart',
    ],
  },
  {
    id: 5,
    name: 'Travel Work Activities',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Business,
    order: 8,
    displayIconIds: [
      'ui_banners_christmas_santa_claus_putting_presents_under_the_tree',
      'ui_banners_technology_collaboration_on_design_like_the_blue_website_header',
      'ui_banners_airport_people_checking_departure_board_waiting_for_their_flight',
      'ui_banners_airport_passport_control',
      'ui_banners_airport_many_nationalities_walking_across_with_their_bags',
      'ui_banners_shopping_man_paying_at_cashier',
    ],
  },
  {
    id: 6,
    name: 'Diverse Circular Portraits',
    isDiverse: true,
    isMono: false,
    permission: UserTypes.Business,
    order: 2,
    displayIconIds: [
      'flat_icons_scenes_interactions_and_communication_chat_skin5',
      'gradient_icons_dating_badge_sunglasses_woman_skin2',
      'gradient_icons_dating_badge_sunglasses_man_skin4',
      'flat_icons_scenes_activities_woman_bowling_skin3',
      'flat_icons_scenes_activities_man_bowling_skin3',
      'flat_icons_scenes_home_sitting_by_the_fireplace_skin1',
      'flat_icons_scenes_home_reading_woman_skin4',
      'gradient_icons_fitness_flip_flop_skin5',
      'gradient_icons_dating_badge_messaging_skin3',
      'gradient_icons_shopping_take_photoes_of_shopping_items_skin4',
    ],
  },
  {
    id: 7,
    name: '2D Faces',
    isDiverse: true,
    isMono: false,
    permission: UserTypes.Premium,
    order: 12,
    displayIconIds: [
      'anatomy_child2_skin2',
      'anatomy_child1_skin3',
      'oldwoman5_skin1',
      'simple_avatarf11_skin4',
      'oldwoman2_skin1',
      'oldwoman1_skin5',
      'avatarm8_skin1',
      'engineer1_skin2',
      'meditating_woman_skin3',
      'disability9_skin2',
    ],
  },
  {
    id: 8,
    name: 'Circular Portraits',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Business,
    order: 10,
    displayIconIds: [
      'gradient_icons_shopping_browse_but_never_buy',
      'gradient_icons_travel_light_hunt',
      'gradient_icons_travel_travel_via_sea',
      'gradient_icons_travel_show_it_off',
      'gradient_icons_travel_airmiles_reward',
      'gradient_icons_travel_kilimanjaro',
      'gradient_icons_travel_japan',
      'gradient_icons_travel_backpacker',
      'gradient_icons_travel_as_long_as_there_is_a_roof',
      'gradient_icons_travel_grab_the_cabs',
    ],
  },
];

export const ICON8_PACK_DATA = [
  {
    category: 'social-networks',
    platform: 'fluent-systems-regular',
    id: 9,
    name: 'Social Media',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 3,
    isIcons8: true,
    displayIconIds: [
      '97E7Dm8qCE2w',
      'z1QKNkhNTYpo',
      '40wKfDQEJsd2',
      'og3NonlQeZ5g',
      '3iSDu4wTLpw2',
      '7WVpwSy9g6hn',
      'FOOSCXOgTsTF',
      '7Gc3zAVnhfkK',
      'BRElTmOLC6Bh',
      'Bl7OpOfLTo7F',
    ],
  },
  {
    category: 'business',
    platform: 'flat_round',
    id: 10,
    name: 'Infographic Business',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 6,
    isIcons8: true,
    displayIconIds: [
      'XN1LvWvQdODo',
      'pnV8VDmzQWzH',
      '81580',
      '81504',
      '81490',
      '81480',
      '81477',
      '81471',
      '81418',
      '81417',
    ],
  },
  {
    category: 'business',
    platform: 'nolan',
    id: 12,
    name: 'Simple Gradient',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 4,
    isIcons8: true,
    displayIconIds: [
      'Q4E4LKr3S5sP',
      'AfM2kzPzTz6Q',
      '6vgrr3Lqd2VN',
      '44798',
      '8aRfr1e1BjwV',
      '6q88zpoPgCAj',
      '5ZDqqbvHOkKs',
      '8MqrQIywEiYc',
      'O4UB7PWd986U',
      'vejcLnEC0H6B',
    ],
  },
  {
    category: 'healthcare',
    platform: 'fluent-systems-filled',
    id: 13,
    name: 'Healthcare Basics',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 7,
    isIcons8: true,
    displayIconIds: [
      '04UrLkmXKjJh',
      'XWqnpSmCXXFz',
      'aw5G4xAlHuSi',
      'YPHGVSBSeMWH',
      '8j5PdwEABwdO',
      'eD6uVdKOtF97',
      'DOkOcdQl69Gf',
      'oA062Rx4qvBs',
      'rBOmteSELnj1',
      'xlATAZUrRNFQ',
    ],
  },
  {
    category: 'business',
    platform: 'dotty',
    id: 14,
    name: 'Office Essentials',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 1,
    isIcons8: true,
    displayIconIds: [
      'cK1fynR8tzXS',
      '101834',
      'dwXrV7cfl0yP',
      'gJdR1tIP4iy1',
      'LXIL6scI4jdy',
      '5b3YHrdAEQSu',
      'WAGpgfrE3f2y',
      'tRiN5GgdL63z',
      'hSZRefS9QZRh',
      'xE0wvp6IA7yM',
    ],
  },
];
